export const DAYS_TO_BOOK = 3 // Used to display urgency tag
